import { makeObservable, observable, action, runInAction } from "mobx";
import queryString from "querystring";

import { getToken } from "../api";
import { convertLanguageCode } from "../utils/convert";
import { setStorage } from "../utils/storage";
import { GlobalErrorType, IApp } from "./appStoreTypes";
import { firebaseEvent, accessType } from "../utils/firebaseEvent";

export default class AppStore {
  constructor() {
    makeObservable(this, {
      appState: observable,
      isInitLoading: observable,
      onInitApp: action,
      apiHeaderState: observable,
      onUpdateToken: action,
      onInitLanguage: action,
      appErrorState: observable,
      onErrorUnknown: action,
    });
  }

  appState: IApp = {
    language: "en",
    languageCode: "en",
  };
  isInitLoading = true;
  onInitApp = async (query: string) => {
    try {
      setStorage("kine_app", query);
      const payload = queryString.parse(query);
      // 첫 history page 표시
      window.history.pushState({ isFirst: true }, "");

      // Init appState
      this.appState = {
        ...this.appState,
        ...payload,
        env: Number(payload.env),
        assetLevel: Number(payload.assetLevel),
        projectLevel: Number(payload.projectLevel),
        share:
          payload.share === "disable" || payload.edition === "China"
            ? false
            : true,
        languageCode: convertLanguageCode(payload.language as string),
      };

      const jsonParams = {
        P1: payload.userType,
        P2: payload.assetLevel,
        P3: payload.projectLevel,
        P4: accessType(),
        P5: window.location.origin,
      };
      firebaseEvent("connection", jsonParams);

      // update apiHeader(token, language)
      await this.onUpdateToken();
      this.apiHeaderState.language = this.appState.language;
    } catch {
      this.onErrorUnknown();
    } finally {
      runInAction(() => (this.isInitLoading = false));
    }
  };

  apiHeaderState = {
    token: "",
    language: "",
  };
  onUpdateToken = async () => {
    const appState = this.appState;
    if (!appState.clientId) return;

    const { data } = await getToken(appState);
    runInAction(() => (this.apiHeaderState.token = data.token));
  };
  onInitLanguage = () => {
    // loco key에 존재하지 않는 언어의 경우 en으로 표시되도록 변경
    this.appState.language = "en";
    this.appState.languageCode = "en";
    this.apiHeaderState.language = "en";
  };

  appErrorState = GlobalErrorType.NONE;
  onErrorUnknown = () => {
    this.isInitLoading = false;
    this.appErrorState = GlobalErrorType.UNKNOWN;
  };
}
